export default __webpack_public_path__ + "static/product7-02287f9f7e72191b82f40d8090315ce7.jpg";